import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { AuthenticationService } from './../../../services/authentication.service';
import {
  DataService,
  ActivityFactory,
  ActivityUtilities,
  Utilities,
  SecurityService
} from 'src/app/services';
import {
  Component,
  OnInit,
  Inject,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  DOCUMENT,
  Input,
  ElementRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkflowService, WorkflowContextService } from '../../../services';
import {
  User,
  WorkflowApplication,
  ApplicationStatus,
  Actions,
  WorkflowType
} from 'src/app/models';
import { Activity, ActivityModel } from 'src/app/models/activities';
import { PaymentRequest } from 'src/app/models/activities/payment-activity';
import { ToastrService } from 'ngx-toastr';

import { GPErrorHandler } from 'src/app/services/gp-error';
import { Subscription } from 'rxjs';
import { EditApplicationNumberComponent } from 'src/app/components/workflow/edit-application-number/edit-application-number.component';
import { svgs } from 'src/assets/export.assets';
import { applicantHomeRoutesNames } from 'src/app/services/mock-data/applicant-home-constants/applicant-home-constants';
import { WorkflowApplicationsJanusService } from '../../admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.service';
import { TableStateService } from '../../applicant/my-applications/table-state-service';
import { Location } from '@angular/common';
import { MyApplicationsService } from '../../applicant/my-applications/my-applications.service';
import { ApplicationPrintSummaryComponent } from '../application-print-summary/application-print-summary.component';

@Component({
  selector: 'wm-application-summary',
  templateUrl: './application-summary.component.html',
  styleUrls: ['./application-summary.component.css'],
  standalone: false
})
export class ApplicationSummaryComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input({ required: false }) appId: string
  @Input({ required: false }) renderPrintMode: boolean
  @Input({ required: false }) getWorkflowApplicationJanusData: boolean
  @Input({ required: false }) bgWhite : boolean
  @Input({required:false}) showPrint= true;
@Input({required:false}) allowReopenChildInspectionApplicationsParentActivityId:string | null;
  @Input({ required: false }) isJanus: boolean//added by priya 20-02-2026
  @Input({ required: false }) editApplicationJanusView: boolean = false
  @Input({ required: false }) includeInProgressActivities: boolean | null = null



  renderJanusUI: boolean;
  submitter: User;
  applicationId: string;
  application: WorkflowApplication;
  workflowId: string;
  applicationUrl: string;
  currentActivity: any;
  summaryActivities: Activity<ActivityModel>[];
  paymentRequests: PaymentRequest[];
  printMode = false;
  showUnDiscardButton = false;
  showReopenApplicationButton = false;
  showReopenClosedApplicationButton = false;
  isTestApplication: boolean;
  totalPaid: number;
  fees = [];
  isEntitledToUnvoid = false;
  isChildApplication = false;
  registrationId: string;
  applicationWorkflowType: WorkflowType;
  WorkflowType = WorkflowType;
  applicationStatus: ApplicationStatus;
  ApplicationStatus = ApplicationStatus;
  canViewVersion = false;
  canEditCompletedApplication = false;
  canReopenApplication = false;
  canReopenClosedApplication = false;
  clientSub: Subscription;

  @ViewChild('RecalculateDescription', { static: true })
  recalculateDescriptionModal: ModalConfirmComponent;
  @ViewChild('UndiscardApplication')
  undiscardApplicationModal: ModalConfirmComponent;
  @ViewChild('reopenApplication')
  reopenApplicationModal: ModalConfirmComponent;

  canEditApplicationNumber = false;
  @ViewChild('editAppNumber', { static: false })
  editAppNumber: EditApplicationNumberComponent;

  apiBase = Utilities.getRootURL();
  closeIcon = svgs.closeIcon.name; //added by priya 20-02-2026
  topMargin: number;
  printIcon = svgs.printIcon.name;
  applicationWorkflowIcon = svgs.applicationWorkflowIcon.name;

  // New Property for Common Modal
  reOpenApplicationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Reopen Application',
    modalSubDescp:
      'Are you sure you want to set this application back to In Progress?',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default',
    customCloseAccepted: true
  };

  constructor(
    private _service: DataService,
    private _route: ActivatedRoute,
    private _workflowSvc: WorkflowService,
    public context: WorkflowContextService,
    private _router: Router,
    private _toastr: ToastrService,
    private _securitySvc: SecurityService,
    @Inject(DOCUMENT) private document: Document,
    private _errorHandler: GPErrorHandler,
    private workflowApplicationsJanusSvc: WorkflowApplicationsJanusService,
    private scrollService: TableStateService,
    private location: Location,
    private myApplicationsService: MyApplicationsService
  ) {}
  ngOnDestroy(): void {
    if (this.clientSub) {
      this.clientSub.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    if (this.printMode) {
      this.document.body.style.backgroundColor = 'white';
    }
  }

  ngOnInit() {
    this.workflowApplicationsJanusSvc.data$.subscribe(data => {
      const updateDescp = data.inlineApplicationSummaryDetails.updateDescp;
      if (updateDescp === true) {
        const descp = data.inlineApplicationSummaryDetails.appDescription;
        this.application.description = descp;
        setTimeout(() => {
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            inlineApplicationSummaryDetails: {
              ...this.workflowApplicationsJanusSvc.getData()
                .inlineApplicationSummaryDetails,
              updateDescp: false
            }
          });
        });
      }
    });
    const init = () => {
      this._securitySvc
        .isLoginEntitled(Actions.VIEW_APPLICATION_VERSION)
        .subscribe(r => {
          this.canViewVersion = r;
        });

      if (this.getWorkflowApplicationJanusData) {
        this._securitySvc
          .isLoginEntitled(Actions.VIEW_APPLICATION_VERSION)
          .subscribe(r => {
            setTimeout(() => {
              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                inlineApplicationSummaryDetails: {
                  ...this.workflowApplicationsJanusSvc.getData()
                    .inlineApplicationSummaryDetails,
                  canViewVersion: r
                }
              });
            });
          });
        this._securitySvc
          .isLoginEntitled(Actions.EDIT_APPLICATION_NUMBER)
          .subscribe(r => {
            setTimeout(() => {
              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                inlineApplicationSummaryDetails: {
                  ...this.workflowApplicationsJanusSvc.getData()
                    .inlineApplicationSummaryDetails,
                  canEditApplicationNumber: r
                }
              });
            });
          });
        this._securitySvc
          .isLoginEntitled(Actions.EDIT_COMPLETED_APPLICATIONS)
          .subscribe(r => {
            setTimeout(() => {
              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                inlineApplicationSummaryDetails: {
                  ...this.workflowApplicationsJanusSvc.getData()
                    .inlineApplicationSummaryDetails,
                  canEditCompletedApplication: r
                }
              });
            });
          });
        this._securitySvc
          .isLoginEntitled(Actions.REOPEN_COMPLETED_APPLICATION)
          .subscribe(r => {
            setTimeout(() => {
              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                inlineApplicationSummaryDetails: {
                  ...this.workflowApplicationsJanusSvc.getData()
                    .inlineApplicationSummaryDetails,
                  canReopenApplication: r
                }
              });
            });
          });
      }

      if (!this.printMode) {
        this._securitySvc
          .isLoginEntitled(Actions.EDIT_COMPLETED_APPLICATIONS)
          .subscribe(r => {
            this.canEditCompletedApplication = r;
          });

        this._securitySvc
          .isLoginEntitled(Actions.REOPEN_COMPLETED_APPLICATION)
          .subscribe(r => {
            this.canReopenApplication = r;
          });

        this._securitySvc
          .isLoginEntitled(Actions.WORKFLOW_APPLICATIONS_EDIT)
          .subscribe(r => {
            this.isEntitledToUnvoid = r;
            this.canReopenClosedApplication = r;
          });

        this._securitySvc
          .isLoginEntitled(Actions.EDIT_APPLICATION_NUMBER)
          .subscribe(r => {
            this.canEditApplicationNumber = r;
          });
      }
    };
    if (this.isJanusUI()) {
      this.applicationId = this.appId;
      this.printMode = this.renderPrintMode;
      this.getApplication();
    } else {
      this._route.params.subscribe(({ applicationId }) => {
        this.applicationUrl = `${window.location.origin}/application/workflow-application-summary/${applicationId}`;
        this.applicationId = applicationId;
        this._route.data.subscribe(d => {
          this.printMode = d.printMode;
          this.isJanus = d.isJanus; //added by priya 20-02-2026
          this.getApplication();
        });
      });
    }

    if (this.context.client) {
      init();
    } else {
      this.clientSub = this.context.client$.subscribe(client => {
        if (!client) {
          return;
        }
        init();
      });
    }
  }
  backClickOfSummary() {
    this.scrollService.enableRestore();
    this.location.back();
  }
  isJanusUI = (): boolean => {
    if ((this.appId && this.renderPrintMode === true) || this.isJanus) {
      return true;
    } else {
      return false;
    }
  }

  // added by amisha 03-06-2026 reason: format the compact applicant mobile summary header text and completed-state icon

  get compactHeaderApplicationText(): string {
    const applicationNumber =
      this.application?.combinedApplicationNumber || this.application?.applicationNumber;

    return applicationNumber ? `Application #${applicationNumber}` : 'Application';
  }

  get compactHeaderStatusText(): string {
    const statusLabel = this.compactStatusLabel;
    const formattedDate = this.formatCompactSummaryDate(this.application?.startedOn);
    const actorName = this.submitter?.name || this.submitter?.userName;

    if (!formattedDate) {
      return actorName ? `${statusLabel} by ${actorName}` : statusLabel;
    }

    if (statusLabel === 'Completed') {
      return actorName
        ? `Completed on ${formattedDate} by ${actorName}`
        : `Completed on ${formattedDate}`;
    }

    if (statusLabel === 'Submitted') {
      return actorName
        ? `Submitted by ${actorName} on ${formattedDate}`
        : `Submitted on ${formattedDate}`;
    }

    return actorName
      ? `${statusLabel} on ${formattedDate} by ${actorName}`
      : `${statusLabel} on ${formattedDate}`;
  }

  get showCompactCompletedIcon(): boolean {
    return this.compactStatusLabel === 'Completed';
  }

  private get compactStatusLabel(): string {
    const applicantStatus = this.application?.applicantStatus?.trim();

    if (applicantStatus) {
      if (applicantStatus === 'Complete') {
        return 'Completed';
      }

      return applicantStatus;
    }

    switch (this.application?.status) {
      case ApplicationStatus.Completed:
        return 'Completed';
      case ApplicationStatus.Voided:
        return 'Voided';
      case ApplicationStatus.Rejected:
        return 'Rejected';
      case ApplicationStatus.InProgress:
        return 'In Progress';
      case ApplicationStatus.NotStarted:
        return 'Not Started';
      default:
        return 'Submitted';
    }
  }

  private formatCompactSummaryDate(dateValue: string | Date | null | undefined): string {
    if (!dateValue) {
      return '';
    }

    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) {
      return '';
    }

    const day = date.getDate();
    let suffix = 'th';

    if (day % 10 === 1 && day !== 11) {
      suffix = 'st';
    } else if (day % 10 === 2 && day !== 12) {
      suffix = 'nd';
    } else if (day % 10 === 3 && day !== 13) {
      suffix = 'rd';
    }

    const formattedDate = date
      .toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long'
      })
      .replace(',', '');

    return `${formattedDate} ${day}${suffix}`;
  }



  editApplicationNumber() {
    this.editAppNumber.open();
  }

  canUnVoid(): boolean {
    return (
      this.application.status === ApplicationStatus.Voided &&
      this.isEntitledToUnvoid
    );
  }

  returnToParent() {
    this._router.navigate([
      'application',
      'workflow-application',
      this.application.parentApplicationId
    ]);
  }

  startRenewalApplication() {
    this._workflowSvc
      .startRegistrationRenewal(this.registrationId)
      .subscribe(result => {
        this._router.navigate([
          '/application/workflow-application',
          result.applicationId
        ]);
      });
  }

  unVoid() {
    this._workflowSvc.undoCloseApplication(this.applicationId).subscribe(r => {
      this._toastr.success('Application Un-Voided');
      this._router.navigate([
        'application',
        'workflow-application',
        this.applicationId
      ]);
    });
  }

  undoCloseApplication() {
    this._workflowSvc.undoCloseApplication(this.applicationId).subscribe(r => {
      this._toastr.success('Application Reopened');
      this._router.navigate([
        'application',
        'workflow-application',
        this.applicationId
      ]);
    });
  }
  //added by priya 20-02-2026
  onBackClick() {
    this.location.back();
  }
  arrowLeftIcon = svgs.arrowLeftIcon.name;
  closeSummary() {
    this.myApplicationsService.selectedApplicationId = null;

    const url = this._router.url;

    const isMyApplications = url.includes(
      applicantHomeRoutesNames.myApplications.route
    );
    const isContractorRoute = url.includes(
      applicantHomeRoutesNames.myContractorRegistrations.route
    );
    if (isMyApplications) {
      this.scrollService.enableRestore();

      this._router
        .navigate(
          [
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            applicantHomeRoutesNames.myApplications.route
          ],
          { queryParamsHandling: 'preserve' }
        )
        .then(() => {
          this.myApplicationsService.triggerRefresh();
        });
    } else if (isContractorRoute){
      this._router
      .navigate(
        [
          '/jurisdiction',
          this.context.client.id,
          applicantHomeRoutesNames.root,
          applicantHomeRoutesNames.myContractorRegistrations.route
        ],
        { queryParamsHandling: 'preserve' }
      )
    }
      else {
      this._router.navigate(
        [
          '/jurisdiction',
          this.context.client.id,
          applicantHomeRoutesNames.root,
          applicantHomeRoutesNames.applyForPermit.route
        ],
        { queryParamsHandling: 'preserve' }
      );
    }
    setTimeout(() => {
      this.enableSummaryInteractions();
    }, 0);
  }
  private enableSummaryInteractions(): void {
    const cards = document.querySelectorAll('.hover-summary-card');
    cards.forEach((el: any) => {
      el.style.pointerEvents = 'auto';
      el.style.cursor = 'pointer';
    });

    const footers = document.querySelectorAll(
      '.alert-summary-footer wm-common-button'
    );
    footers.forEach((el: any) => {
      el.style.setProperty('--button-font-color', '#2196F3', 'important');
      el.style.pointerEvents = 'auto';
      el.style.cursor = 'pointer';
    });
  }

  //end by priya 20-02-2026
  getApplication() {
    this._service
      .getApplicationSummary(this.applicationId, this.isJanusUI(), this.context?.useNewLayout===true)
      .subscribe(appSummary => {
        this.context.applicationId$.emit(this.applicationId);
        if (appSummary) {
          this.workflowId = appSummary.workflowId;
          this.application = appSummary.application;
          if (this.getWorkflowApplicationJanusData === true) {
            setTimeout(() => {
              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                inlineApplicationSummaryDetails: {
                  ...this.workflowApplicationsJanusSvc.getData()
                    .inlineApplicationSummaryDetails,
                  updateUserNameAndAppNo: true,
                  userName: this.submitter.name,
                  clientApplicationNumber: '',
                  combinedApplicationNumber:
                    appSummary.application.combinedApplicationNumber,
                  workflowId: appSummary.workflowId,
                  versionId: appSummary.application.workflowVersionId
                }
              });
            });
          }
          this.isTestApplication = appSummary.application.isTestApplication;
          this.context.isTestApplication$.emit(
            appSummary.application.isTestApplication
          );
          this.isChildApplication = appSummary.application.hasParentApplication;
          this.registrationId = appSummary.registrationId;
          this.applicationWorkflowType = appSummary.workflowType;
          this.applicationStatus = appSummary.application.status;

          if(appSummary.application.status !== 1 && appSummary.application.status !== 2  && this.context.janusLayout === 'staff' && this.allowReopenChildInspectionApplicationsParentActivityId){
            this.reOpenApplicationModalData = {
          ...this.reOpenApplicationModalData,
          open: true
        }
          }
          this.showUnDiscardButton =
            appSummary.application.status === ApplicationStatus.Discarded;
          this.showReopenApplicationButton =
            appSummary.application.status === ApplicationStatus.Completed ||
            appSummary.application.status === ApplicationStatus.Rejected;
          setTimeout(() => {
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              inlineApplicationSummaryDetails: {
                ...this.workflowApplicationsJanusSvc.getData()
                  .inlineApplicationSummaryDetails,
                showReopenApplicationButton:
                  appSummary.application.status ===
                    ApplicationStatus.Completed ||
                  appSummary.application.status === ApplicationStatus.Rejected
              }
            });
          });
          this.showReopenClosedApplicationButton =
            appSummary.application.status === ApplicationStatus.Expired ||
            appSummary.application.status === ApplicationStatus.Locked ||
            appSummary.application.status === ApplicationStatus.Withdrawn;
          const activities = ActivityUtilities.convertActivitiesJsonToClasses(
            appSummary.completedActivities
          );
          // convert the dictionary to an array
          const convertedActivities = Object.keys(activities).map(
            key => activities[key]
          );
          this.summaryActivities = convertedActivities;

          this.fees = appSummary.fees;
          this.totalPaid = appSummary.totalPaid;
          this.submitter = appSummary.submitter;
        }
        this._service
          .getPaymentRequests(this.applicationId)
          .subscribe(requests => {
            this.paymentRequests = requests;
          });
      });
  }

  exitTestApplication() {
    this._workflowSvc.cleanupTestApplication(this.applicationId).subscribe(
      a => {
        this.context.applicationId$.emit(null);
        this.context.viewAsRole$.emit(null);
        this.context.testAsData$.emit(null);
        this._router.navigate([this.context.applicationReturnURL]);
      },
      err => {
        this._errorHandler.handleError(err);
      }
    );

    return false;
  }

  openApplicationWorkflowBuilder() {
    const workflowId = this.workflowId;
    const versionId = this.application.workflowVersionId;

    const url = this._router.serializeUrl(
      this._router.createUrlTree([
        '/admin/workflow-builder/',
        workflowId,
        versionId,
        this.application.id
      ])
    );

    window.open(url, '_blank');
  }

  undiscardApplication(force: boolean) {
    if (!force) {
      this.undiscardApplicationModal.open();
    } else {
      this._workflowSvc
        .undiscardApplication(this.applicationId)
        .subscribe(app => {
          this.undiscardApplicationModal.cancel();
          this._router.navigate([
            '/application/workflow-application/',
            this.applicationId
          ]);
        });
    }
  }

  setApplicationBackToInProgress(force: boolean) {
    if (!force) {
      if (this.isJanusUI() && this.context.janusLayout === 'applicant') {
        this.reOpenApplicationModalData = {
          ...this.reOpenApplicationModalData,
          open: true
        };
      } else {
        this.reopenApplicationModal.open();
      }
    } else {
      this._workflowSvc
        .reopenApplication(this.applicationId)
        .subscribe(result => {
          if (result) {
            // Cancel the standard modal if it exists
            if (this.reopenApplicationModal) {
              this.reopenApplicationModal.cancel();
            }

            // Close the common confirmation modal
            this.reOpenApplicationModalData = {
              ...this.reOpenApplicationModalData,
              open: false
            };

            // Navigate correctly based on layout context
            if (this.isJanusUI() && this.context.janusLayout === 'applicant') {
              const url = this._router.url;
              const isMyApplications = url.includes(
                applicantHomeRoutesNames.myApplications.route
              );
              const currentRoute = isMyApplications
                ? applicantHomeRoutesNames.myApplications.route
                : applicantHomeRoutesNames.applyForPermit.route;

              this._router.navigate(
                [
                  '/jurisdiction',
                  this.context.client.id,
                  applicantHomeRoutesNames.root,
                  currentRoute,
                  'workflow-application',
                  this.applicationId,
                  this.workflowId
                ],
                { queryParamsHandling: 'preserve' }
              );
            } else {
              this._router.navigate([
                '/application/workflow-application/',
                this.applicationId
              ]);
            }
          } else {
            this._toastr.error(
              'Failed to set application to In Progress.  Please contact support if this error persists.'
            );
          }
        });
    }
  }

  // Handlers for common-confirmation-modal
  handleReOpenApplicationModalAccepted() {
    if(this.context.janusLayout === 'staff'){
      if(this.applicationStatus === 5){
      this._workflowSvc
      .undiscardApplication(this.appId)
      .subscribe(result => {
        if (result) {
this.workflowApplicationsJanusSvc.setData({
  ...this.workflowApplicationsJanusSvc.getData(),
  reRunCurrentInlineActivity:this.allowReopenChildInspectionApplicationsParentActivityId
})
          this.reOpenApplicationModalData = {
            ...this.reOpenApplicationModalData,
            open: false
          }


          this._toastr.success(`Application set to In Progress again`);
        } else {
          this._toastr.error('Failed to set application to In Progress.  Please contact support if this error persists.');
        }
      });
    }else{
      this._workflowSvc
      .undoCloseApplication(this.appId)
      .subscribe(result => {
        if (result) {
this.workflowApplicationsJanusSvc.setData({
  ...this.workflowApplicationsJanusSvc.getData(),
  reRunCurrentInlineActivity:this.allowReopenChildInspectionApplicationsParentActivityId
})
          this.reOpenApplicationModalData = {
            ...this.reOpenApplicationModalData,
            open: false
          }
          this._toastr.success(`Application set to In Progress again`);
        } else {
          this._toastr.error('Failed to set application to In Progress.  Please contact support if this error persists.');
        }
      });
    }


    }else if(this.context.janusLayout === 'applicant'){
this.setApplicationBackToInProgress(true);
    }

  }

  handleReOpenApplicationModalRejected() {
    this.reOpenApplicationModalData = {
      ...this.reOpenApplicationModalData,
      open: false
    };
  }

  recalculateApplicationDescription(force: boolean) {
    if (!force) {
      this.recalculateDescriptionModal.open();
    } else {
      this._workflowSvc
        .recalculateApplicationDescription(this.applicationId)
        .subscribe(appDescription => {
          this.application.description = appDescription;
          this.recalculateDescriptionModal.cancel();
        });
    }
  }

  setTopMarginForNavbar(pixelHeight: number) {
    this.topMargin = pixelHeight;
  }
  // added by priya 24-02-2026
  @ViewChild('printSection') printSection!: ElementRef;
  // Added by amisha on 26-05-2026 to prepare print-only assets like parcel map screenshots
  // before the summary HTML is copied into the print document.
  @ViewChild(ApplicationPrintSummaryComponent, { static: false })
  printSummaryComponent: ApplicationPrintSummaryComponent;
  async onPrint(): Promise<void> {
    if (this.printSummaryComponent) {
      await this.printSummaryComponent.prepareForPrint();
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    const printContents = this.printSection.nativeElement.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;

    window.location.reload();
  }
  // end by priya 24-02-2026
}
